import MaterialButton from "../../../../__snowpack__/pkg/@mui/material/Button.js";
import styled from "styled-components";
export const ButtonContainer = styled(MaterialButton).withConfig({
  displayName: "buttonstyles__ButtonContainer",
  componentId: "sc-7cdxkn-0"
})(["", ""], ({
  size
}) => size === "small" && "height: 2.5rem;");
